var React = require('react');

function ServiceNowOLogo (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#62D84E","d":"M186.6,30c-6.7,0-12.3,5.5-12.4,12.3c0,3.6,1.5,6.8,3.9,9.1c0.9,0.8,2.2,0.9,3.2,0.2c1.4-1.1,3.2-1.7,5.3-1.7\n\tc2.1,0,3.9,0.7,5.3,1.7c1,0.7,2.3,0.7,3.2-0.2c2.4-2.3,3.8-5.4,3.8-9C198.8,35.5,193.4,30,186.6,30 M186.5,48.5\n\tc-3.7,0-6.2-2.8-6.2-6.2c0-3.4,2.5-6.2,6.2-6.2c3.7,0,6.2,2.8,6.2,6.2C192.7,45.8,190.2,48.5,186.5,48.5"}));
}

ServiceNowOLogo.defaultProps = {"version":"1.1","viewBox":"174.2 30 24.7 22.1"};

module.exports = ServiceNowOLogo;

ServiceNowOLogo.default = ServiceNowOLogo;
